import type { SvgIconProps } from './types.js';

const BringLogo = ({ width = 42, height = 16 }: SvgIconProps) => (
    <svg
        width={width}
        height={height}
        viewBox="0 5 126 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title>Bring logo</title>
        <g clipPath="url(#clip0_24124_22163)">
            <path
                d="M57.0402 26.49C55.0302 26.49 52.8402 26.72 51.4402 28.16V20.85H47.1602V45.27H51.0202V43.79C52.5102 45.03 54.4202 45.66 56.3602 45.57C63.7402 45.57 64.2302 40.57 64.2302 36.07C64.2302 30.47 63.3602 26.49 57.0402 26.49ZM56.0902 41.71C52.4202 41.71 51.3602 40.69 51.3602 36.07C51.3602 31.45 52.4202 30.43 56.0902 30.43C59.2702 30.43 59.9502 31.75 59.9502 36.07C59.9502 40.39 59.2702 41.71 56.0902 41.71ZM75.2302 26.49C73.3402 26.39 71.4902 27.11 70.1602 28.46V26.82H66.4502V45.27H70.7302V37.24C70.6202 35.62 70.7602 34 71.1502 32.43C71.6502 31.04 73.0102 30.14 74.4802 30.24C76.2602 30.24 76.9702 30.62 76.9702 32.32H81.2202C81.2202 28.27 79.2102 26.49 75.2402 26.49M99.3602 26.49C97.4202 26.39 95.5102 27.02 94.0202 28.27V26.81H90.3102V45.26H94.5902V36.67C94.5902 33.45 94.2502 30.27 98.8702 30.27C102.58 30.27 102.24 31.97 102.24 35.53V45.26H106.52V35.19C106.52 31.18 106.82 26.48 99.3702 26.48M121.93 26.81V28.27C120.27 27.03 118.24 26.4 116.18 26.49C109.82 26.49 108.8 30.31 108.8 35.92C108.8 40.34 109.22 45.27 116.22 45.27C118.12 45.36 120 44.79 121.52 43.64C121.55 44.72 121.52 45.79 121.45 46.87C121.22 48.61 119.44 49.37 116.98 49.37C114.52 49.37 113.84 48.7 113.84 47.37H109.18C109.18 52.07 113.38 53 117.09 53C120.5 53 124.97 52.09 125.65 47.7C125.79 46.24 125.84 44.77 125.8 43.3V26.81H121.93ZM116.9 41.41C113.72 41.41 113.08 40.24 113.08 35.92C113.08 31.6 113.72 30.28 116.9 30.28C120.57 30.28 121.56 31.3 121.56 35.92C121.56 40.54 120.58 41.41 116.9 41.41ZM83.2602 45.27H87.5402V26.82H83.2602V45.27ZM83.2602 25.14H87.5402V20.86H83.2602V25.14Z"
                fill="#56B529"
            />
            <path
                d="M22.59 26.81C22.15 32.26 17.61 36.45 12.14 36.46C6.68 36.46 2.13 32.26 1.69 26.81H0C0.45 38.05 9.7 46.94 20.95 46.94C32.2 46.94 41.45 38.05 41.9 26.81H22.59Z"
                fill="#B5E099"
            />
            <path
                d="M1.69 25.14C2.18 19.37 7.25 15.09 13.02 15.57C18.12 16 22.16 20.04 22.59 25.14H41.9C41.44 13.57 31.69 4.56 20.12 5.02C9.19 5.45 0.43 14.21 0 25.14H1.69Z"
                fill="#56B529"
            />
        </g>
        <defs>
            <clipPath id="clip0_24124_22163">
                <rect width="125.81" height="48" fill="white" transform="translate(0 5)" />
            </clipPath>
        </defs>
    </svg>
);

export default BringLogo;
